import React from "react";

import { noop } from "lodash";

import { useFilteredTransitionTasks } from "../hooks/useFilteredTransitionTasks";
import TransitionHeader from "../ui/TransitionHeader";
import TransitionProgressInfo from "../ui/TransitionProgressInfo";
import TransitionTasksTable from "../ui/TransitionTasksTable/TransitionTasksTable";

const TransitionTasks: React.FC = () => {
  const {
    sortedTasks,
    isLoading,
    hasError,
    handleSort,
    handleRetry,
    paginationProps,
    sortingProps,
  } = useFilteredTransitionTasks("transition-tasks");

  return (
    <div>
      <TransitionHeader
        title="Tasks Being Done for You"
        subtitle="Transition Tasks"
        rightContent={
          <TransitionProgressInfo
            totalTasks={sortedTasks.length}
            showPercentage={false}
          />
        }
      />

      <TransitionTasksTable
        tasks={sortedTasks}
        loading={isLoading}
        error={hasError ? new Error("Failed to load transition tasks") : null}
        pagination={paginationProps}
        sorting={sortingProps}
        onPageChange={noop} // No-op since we don't have pagination
        onSort={handleSort}
        onRetry={handleRetry}
        storageKey="farther:layout:transition-tasks-column-widths"
      />
    </div>
  );
};

export default TransitionTasks;
